import { Box, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function LandingCard({ title, tooltip = null, action = null, ...props }) {
  return (
    <Box
      {...props}
      sx={{
        borderRadius: 3,
        border: (theme) => "1px solid " + theme.palette.background.border,
        padding: 2,
        backgroundColor: "white",
        ...props.sx,
      }}
    >
      <Box width="100%" display="flex" alignItems="center" justifyContent="space-between" pb={3}>
        {title && (
          <Typography fontWeight="700" fontSize={20} alignSelf="flex-start">
            {title}
          </Typography>
        )}
        <Box display="flex" alignItems="center" gap={1}>
          {action}
          {tooltip && (
            <Tooltip title={tooltip}>
              <InfoOutlinedIcon sx={{ ml: 1, cursor: "pointer", opacity: 0.2 }} />
            </Tooltip>
          )}
        </Box>
      </Box>

      {props.children}
    </Box>
  );
}

export default LandingCard;
